import { useAddSpaceModal } from "@/react/components/Modals/AddSpaceModal";
import { canManageSpaceGroups } from "@circle-react/helpers/spaceGroupHelpers";

export const useSpaceGroupHeader = ({ spaceGroup }) => {
  const spaceModal = useAddSpaceModal();
  const canManage = canManageSpaceGroups({ spaceGroup });

  return {
    spaceModal,
    canManage,
  };
};
